import React from 'react';

import Link from 'components/atoms/Link';
import Button, { ButtonProps } from 'components/molecules/Button';

export type ButtonBarProps = {
	id?: string;
	buttonsLayout?: string;
	buttons: ButtonProps[];
	loading?: boolean;
	disabled?: boolean;
	handleButtonClicks?: (...args: any) => any;
};

const ButtonBar = ({
	buttonsLayout,
	buttons = [],
	handleButtonClicks,
	disabled = false,
	loading = false,
}: ButtonBarProps) => {
	return (
		<ul className={`m-button-bar${buttonsLayout ? ` m-button-bar--${buttonsLayout}` : ''}`}>
			{buttons &&
				buttons.map((button: ButtonProps, index: number) => {
					let _loading: boolean = button.loading || loading;
					let _disabled: boolean = button.disabled || disabled;
					const _key: string = button.key ? `${button.key}_${index}` : index.toString();

					// use disabled in case of button is arrow right or left
					if (
						_loading &&
						button &&
						button.knob &&
						(button.knob.icon === 'arrow-left' || button.knob.icon === 'arrow-right')
					) {
						_loading = false;
						_disabled = true;
					}

					return (
						<li key={_key} className="m-button-bar__button">
							{button.knob && (
								<Button
									loading={_loading}
									disabled={_disabled}
									type={button.type}
									knob={button.knob}
									link={button.link}
									modifier={button.modifier}
									handleButtonClick={handleButtonClicks}
									labelTop={button.labelTop}
									labelBottom={button.labelBottom}
								/>
							)}
							{button.link && (
								<Link
									{...button.link}
									loading={_loading}
									disabled={_disabled}
									onClick={handleButtonClicks}
								/>
							)}
						</li>
					);
				})}
		</ul>
	);
};

export default ButtonBar;
